export default __webpack_public_path__ + "static/media/jenkins.18b2a1e4.svg";